import { client } from "api";

export type SyncToPyramidRequest = string;
export type SyncToPyramidResponse = { reportToken: string };

export const syncToPyramid = (orderId: SyncToPyramidRequest) =>
  client.post<SyncToPyramidResponse>(`/pyramid/sync-to-pyramid/${orderId}`).then((res) => res.data);
